<template>
<div>
  <div id="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
    Drop file here to import or click
    <input
      type="file"
      ref="fileUploader"
      id="fileElem"
      v-if="uploadReady"
      v-on:change="manualFileUpload()"
      class="file-input"
    />
    <v-btn @click="launchUploadDialog()">here</v-btn>
  </div>
  <img :src="targetImg" alt="fixation target"/>
  </div>
</template>

<script>
import target from '@/assets/fixation.png';

export default {
  data() {
    return {
      targetImg: target
    }
  },
  methods: {
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      console.log('File dropped');
      // var files = e.dataTransfer.files, i, f;
      this.handleFileUpload(e.dataTransfer.files);
    },
    async handleFileUpload(uploadedFiles) {
      for (let i = 0, f = uploadedFiles[i]; i !== uploadedFiles.length; i += 1) {
        const self = this;
        const reader = new FileReader();
        reader.onload = async (e) => { }
      }
    }
  }
}
</script>
<style scoped>
#drop {
  border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  padding: 25px;
  text-align: center;
  font: 16pt;
  color: #999;
}
</style>